import { message } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import React, { useEffect, useRef, useState } from 'react';
import PrintComponents from 'react-print-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchAccountAdvisors } from '../../../../actions/globalActions';
import printIcon from '../../../../assets/icons/print.svg';
import BreadcrumbComponent from '../../../../CommonComponents/Breadcrumb/Breadcrumb';
import {
  GeneralButton, TooltipWrapper
} from '../../../../CommonComponents/Commons/commonComponents';
import {
  FixedWidth,
  StyleLessButton,
  CommonListWrapper
} from '../../../../CommonComponents/commonStyles';
import {
  ContentProvider,
  Types,
  ContentMessage
} from '../../../../CommonComponents/ContentMessages';
import PageAccountSummary from '../../../../CommonComponents/PageSummary/PageAccountSummary/PageAccountSummary';
import Preloader from '../../../../CommonComponents/Preloader/Preloader';
import TimeLine from '../../../../CommonComponents/TimeLine/TimeLine';
import {
  initiateTracking,
  milliToDate,
  recordError,
  isAllShareAllPool
} from '../../../../utils/commonUtil';
import { getPrimaryAccount } from '../../../../utils/sessionUtil';
import { DataExportPrint, IconPadding } from '../../../MyAccounts/styles';
import { fetchGrantData } from '../GrantsActivity/actions';
import {
  addSpawn,
  cancelAllSchedules,
  cancelGrantFlow,
  cancelSchedule, changeScheduleId, enableEdit, enableRegrant, grantDetailsLoader, newGrant,
  resetEdit
} from './actions';
import FlowFooter from "./Component/FlowFooter/FlowFooter";
import Note from './Component/Note/Note';
import DrupalPopup from './Component/Popup/DrupalPopup';
import RecurringTable from './Component/RecurringTable/RecurringTable';
import EditSpawn from './Component/ViewEditSchedules/Components/EditSpawn';
import Heading from './Component/ViewEditSchedules/Components/Heading';
import InfoInline from './Component/ViewEditSchedules/Components/InfoInline';
import PermissionToPublish from './Component/ViewEditSchedules/Components/PermissionToPublish';
import PreviewLetter from './Component/ViewEditSchedules/Components/PreviewLetter';
import Step1Summary from './Component/ViewEditSchedules/Components/Step1Summary';
import Step2Summary from './Component/ViewEditSchedules/Components/Step2Summary';
import { viewGrantDetailDerivedStates } from './Selectors/ViewGrantDetailSelectors';
import {
  ButtonWrapper, ClearedDateSection, CustomPagesHeading, LabelWrapper,
  LinkWrapper,
  SectionMediumDivider,
  StatusSection, ViewEditBtnContainer,ItemHeading
} from './style';
import prepareRender, { checkSpawnEdit } from './utils';
import ViewGrantDetailsPrint from './ViewGrantDetailsPrint';



const breadcrumbRoutes = (isGrantView, isGrantAgreementPayment) => {
  // TODO : isGrantView should be removed from entire page once isGrantAgreementPayment is received from API.
  if (isGrantView || isGrantAgreementPayment) {
    return [
      {
        routeName: 'Home',
        path: '/',
      },
      {
        routeName: 'Grants',
        path: '/grants',
      },
      {
        routeName: 'Grant Activity',
        path: '/grants/activity',
      },
      {
        routeName: 'View Grant Agreement',
        path: '',
      },
    ];
  }
  return [
    {
      routeName: 'Home',
      path: '/',
    },
    {
      routeName: 'Grants',
      path: '/grants',
    },
    {
      routeName: 'Grant Activity',
      path: '/grants/activity',
    },
    {
      routeName: 'View and Edit Grant',
    },
  ];
};

const editable = (props) => {
  const {
    role,
    isGrantView,
    isGrantAgreementPayment,
    spawnId,
    scheduleStatus,
    status,
    allowEdit = true,
    scheduleType,
    csrBusinessFunction
  } = props;
  if ((role && role.access === 'Read Only') || isGrantView || isGrantAgreementPayment)
    return false;
  else {
    if (spawnId) {
      return checkSpawnAccess(spawnId,allowEdit,status,scheduleStatus,csrBusinessFunction);
    }
    if (scheduleType === 'recurring') {
      if (status === 'Active' || status === 'Entered') return true;
      return false;
    } else {
      if (status === 'Research proceeding' || status === 'Entered') return true;
      return false;
    }
  }
};

const checkSpawnAccess = (spawnId,allowEdit,status,scheduleStatus,csrBusinessFunction)=>{
  if(spawnId)
  {
    if(allowEdit)
    {
      return  checkSpawnEdit(status,scheduleStatus,csrBusinessFunction)
    }
    else{
      return false;
    }
  }

}

const showRegrant = (role, scheduleType, status) => {
  if (role && role.access === 'Read Only') return false;
  return (
    scheduleType === 'oneTime' &&
    (status === 'Payment issued' || status === 'Payment completed')
  );
};

export const regrantFlow = (enableRegrant, history) => {
  try {
    enableRegrant();
    history.push({ pathname: '/grants/recommend/review' });
  } catch (error) {
    recordError(error);
  }
};

export const scheduleRedirect = (history, scheduleIdForSpawns) => {
  try {
    history.push({
      pathname: '/grants/activity/view',
      search: `?scheduleId=${scheduleIdForSpawns}`,
    });
  } catch (error) {
    recordError(error);
  }
};
export const reGrantRender = (availableBalance, grantAmount, regrantHandler) => {
  let isAllShareAllPoolStatus = isAllShareAllPool();
  if (availableBalance < 1) {
    return (
      <TooltipWrapper
        text="You do not have sufficient balance in your account for regrant."
        placement="top"
        element={
          <ViewEditBtnContainer>
            <GeneralButton
              id="btnRegrant1"
              disabled={true}
              type="functional"
              text="REGRANT"
              width="150px"
            />
          </ViewEditBtnContainer>
        }
      ></TooltipWrapper>
    );
  } else if (isAllShareAllPoolStatus) {
    return (
      <TooltipWrapper
        text="A grant has been recommended to close the account. Additional grant transactions cannot be submitted."
        placement="top"
        element={
          <ViewEditBtnContainer>
            <GeneralButton
              id="btnRegrant1"
              disabled={true}
              type="functional"
              text="REGRANT"
              width="150px"
            />
          </ViewEditBtnContainer>
        }
      ></TooltipWrapper>
    );
  }else if (grantAmount < 500) {
    return (
      <TooltipWrapper
        text="Regrant is unavailable for grant amount less than $500.00."
        placement="top"
        element={
          <ViewEditBtnContainer>
            <GeneralButton
              id="btnRegrant2"
              disabled={true}
              type="functional"
              text="REGRANT"
              width="150px"
            />
          </ViewEditBtnContainer>
        }
      ></TooltipWrapper>
    );
  } else {
    return (
      <ViewEditBtnContainer>
        <GeneralButton
          id="btnRegrant3"
          type="functional"
          text="REGRANT"
          width="150px"
          onClick={regrantHandler}
        />
      </ViewEditBtnContainer>
    );
  }
};

export const ViewGrantDetails = (props) => {
  const {
    loading = true,
    location,
    fetchGrantData,
    cancelSingleSpawn,
    cancelAllSpawns,
    cancelSingleStatus,
    cancelAllStatus,
    addSpawn,
    history,
    enteredDate,
    status,
    spawns,
    scheduleType,
    scheduleStatus,
    grantDetailsLoader,
    checkIssuedDate,
    csrBusinessFunction,
    checkNumber,
    isGrantAgreementPayment,
    grantTimeline,
    startDate,
    fastPass,
    grantAgreementId,
  } = props;

  const { grantId, scheduleId} = queryString.parse(location.search);
  let {spawnId} =  queryString.parse(location.search);
  if(!spawnId)
  {
    spawnId = location?.state?.spawnId;
  }
  let checkClearedDate =
    props.checkClearedDate && milliToDate(props.checkClearedDate);
  const {
    userId: accountId,
    accountName,
    accountNumber,
    role,
  } = getPrimaryAccount();
  let refreshInterval = null;

  // perform on load
  useEffect(() => {
    props.resetEdit();
    props.changeScheduleId(scheduleId);
    props.fetchAdvisors({ accountId });
  }, []);

  const printRef = useRef();
  const editSpawnRef = useRef();

  //This is the function to refresh the Grant details API in every 8 minutes because the key for payment link will be renewed in every 8 minutes.
  const refreshApi = () => {
    refreshInterval = setInterval(
      () =>
        fetchGrantData({
          userId: accountId,
          grantId,
          scheduleId: scheduleIdSelector(),
          spawnId,
        }),
      480000
    );
  };

  useEffect(() => {
    if (!grantId && !scheduleId && !spawnId) {
      setError(true);
      return;
    }
    window.scrollTo(0, 0);
    grantDetailsLoader();

    fetchGrantData({
      userId: accountId,
      grantId,
      scheduleId: scheduleIdSelector(),
      spawnId,
    });
    // API should be refreshed only for spawn of a schedule and one time grants.
    if (props.paymentLetterLink && (spawnId || grantId)) refreshApi();
  }, [grantId, scheduleId, spawnId]);

  useEffect(() => {
    if (cancelSingleStatus || cancelAllStatus) {
      fetchGrantData({
        userId: accountId,
        grantId,
        scheduleId: scheduleIdSelector(),
        spawnId,
      });
    }
  }, [cancelAllStatus, spawnId, cancelSingleStatus, spawns]);

  useEffect(() => {
    return () => {
      if (refreshInterval) clearInterval(refreshInterval);
    };
  }, []);

  const [showError, setError] = useState(false);
  const [showAllocationEdit, setShowAllocationEdit] = useState(false);
  const [grantPurposeEdit, setGrantPurposeEdit] = useState(false);
  const [showSpawnRegrantWarning, setShowSpawnRegrantWarning] = useState(false);
  const { isSpawn: isSpawnFlow } = location.state ? location.state : {};

  const scheduleIdSelector = () => {
    if (grantId) return ''; //Should not be invoked if it is single grant flow
    return scheduleId ? scheduleId : props.location.state.scheduleId;
  };

  const backToScheduleHandler = () => {
    initiateTracking(
      'back2',
      `${
        editable({spawnId, ...props, role,csrBusinessFunction }) ? `View and Edit ` : `View `
      }Recurring Grant Spawn`,
      '',
      'Back to Schedule'
    );
    history.push({
      pathname: '/grants/activity/view',
      search: queryString.stringify({
        scheduleId: props.location.state.scheduleId,
      }),
    });
  };

  const SecondaryNavigation = ({readonly}) =>(
   !( spawnId && checkSpawnEdit(status,scheduleStatus,csrBusinessFunction) && !readonly )?
    (spawnId)?
    
     (<ViewEditBtnContainer btnWithMargin>
        <GeneralButton
          id="btnBackToSchedule"
          type="functional"
          text="BACK TO SCHEDULE"
          inverted
          onClick={() => backToScheduleHandler()}
        />
      </ViewEditBtnContainer>
)
    :
    (<ViewEditBtnContainer btnWithMargin>
        <GeneralButton
          id="btnViewAllGrants"
          type="functional"
          text="VIEW ALL GRANTS"
          inverted
          onClick={() => {
            try {
              history.push({ pathname: '/grants/activity' });
            } catch (error) {
              recordError(error);
            }
          }}
        />
      </ViewEditBtnContainer>)
      :null
    
    );

  const {
    charityInfo,
    purposeRecognition,
    publishName,
    amountAllocation,
    scheduleData,
    codeValueMappingData,
  } = prepareRender(props);

  const cancelApi = (currentSpawnId, type, status) => {
    analyticsHandler(
      `${type === 'all' ? `cancel2` : `cancelTable`}`,
      `${status ? status : ''}`,
      `${
        type === 'all' ? `Cancel all remaining payments` : `Cancel`
      } - Recurring Grant`
    );
    let spawnIndex;
    const spawn = props.spawns.filter((spawn, index) => {
      if (spawn.spawnId === currentSpawnId) {
        spawnIndex = index;
        return spawn;
      }
    });
    switch (type) {
      case 'all':
        return cancelAllSpawns({
          userId: accountId,
          cancelData: {
            accountId: accountId,
            scheduleId: scheduleId,
            grantType: 'recurring',
          },
          successFn: () => {
            message.success(
              'All remaining payments have been cancelled successfully.'
            );
          },
          failureFn: () => {
            message.error('Sorry, Something went wrong.');
          },
        });
      case 'single':
        return cancelSingleSpawn({
          userId: accountId,
          scheduleId: scheduleId,
          pendingSpawnId: currentSpawnId,
          cancelData: {
            accountId: accountId,
            scheduleId: scheduleId,
            pendingSpawnId: currentSpawnId,
            grantType: 'recurring',
          },
          successFn: () => {
            if (spawn.length) {
              message.success(
                `Spawn '${spawn[0].charityDetails.charityName} | ${
                  spawnIndex + 1
                }' has been cancelled successfully.`
              );
            }
          },
          failureFn: () => {
            message.error('Sorry, Something went wrong.');
          },
        });
    }
  };

  const analyticsHandler = (dataLayerName, event, name) => {
    try {
      initiateTracking(
        dataLayerName,
        editable({ spawnId,...props, role }) ? 'View and Edit Grant' : 'View Grant',
        event,
        name
      );
    } catch (error) {
      recordError(error);
    }
  };

  const addGrantApiCall = () => {
    analyticsHandler(
      'addGrant',
      'Recurring Grant Schedule',
      'Add Grant - Recurring Grant'
    );
    addSpawn({
      userId: accountId,
      scheduleId,
      successFn: () => {
        message.success(
          `A new spawn '${
            props.spawns[props.spawns.length - 1].charityDetails.charityName
          } | ${props.spawns.length + 1}' has been added to the schedule.`
        );
      },
      failureFn: () => {
        message.error('Sorry, Something went wrong.');
      },
    });
  };

  const regrantHandler = () => {
    if (spawnId || isSpawnFlow) {
      setShowSpawnRegrantWarning(true);
    } else {
      regrantFlow(props.enableRegrant, history);
    }
  };

  const viewHandle = ({ spawnId, edit, scheduledIssueDate }) => {
    analyticsHandler(
      'buttonStep',
      'Recurring Grant Schedule',
      `${edit ? `View and Edit` : `View`}`
    );

    let location = {
      pathname: '/grants/activity/view',
      search: queryString.stringify({
        spawnId: spawnId,
      }),
      state: { scheduleId, scheduledIssueDate },
    };
    if(edit)
    {
      props.enableEdit();
       location = {
        pathname: '/grants/activity/edit/step2A',
        state: { scheduleId, scheduledIssueDate,spawnId},
      };
      
    }
   
    props.history.push(location);
  };

  if (loading) {
    return (
      <ContentProvider types={[Types.PAGE_ALERTS]} pages={['Edit Grant']}>
        <DrupalPopup
          html={true}
          page={'Edit Grant'}
          show={showError}
          defaultPrimaryLabel={'Ok'}
          defaultTitle={'Something went wrong at our end'}
          showSecondary={false}
          keyProperty={'Edit Grant API error'}
          defaultDescription={
            'We do not understand the request. Please try again!'
          }
          primaryCta={() => setError(false)}
          alertId="edit-grants"
        />
        <Preloader />
      </ContentProvider>
    );
  }

  const purposeHandle = () => {
    if (scheduleType === 'recurring') {
      setGrantPurposeEdit(true);
    } else {
      props.enableEdit();
      history.push('/grants/activity/edit/purpose');
    }
  };

  const prProps = {
    ...purposeRecognition,
    edit: editable({ spawnId,allowEdit:false,...props, role }),
    handleEdit: () => purposeHandle(),
  };

  const PrintText = (props) => {
    return (
      <DataExportPrint>
        <a
          onClick={() =>
            analyticsHandler(
              'print',
              '',
              `Print${
                scheduleType === 'recurring'
                  ? ` - Recurring Grant`
                  : ` - One Time Grant`
              }`
            )
          }
        >
          {props.children}
        </a>
      </DataExportPrint>
    );
  };

  const currentScheduleId = spawnId
    ? props.location.state.scheduleId
    : scheduleId;

  const isLegacy =
    moment(enteredDate, 'MM/DD/YYYY') > moment('05/28/2009', 'MM/DD/YYYY');
  return (
    <ContentProvider types={[Types.PAGE_ALERTS]} pages={['Edit Grant']}>
      <FixedWidth>
        <div ref={printRef}>
          <BreadcrumbComponent
            className="hide-for-print"
            breadcrumbRoutes={breadcrumbRoutes(
              props.isGrantView,
              isGrantAgreementPayment
            )}
          />
          <div className="items-baseline">
            <CustomPagesHeading className="mb-50" letterSpace="0.5px">
              {scheduleId || spawnId
                ? `Schedule ID: ${currentScheduleId}`
                : `Transaction ID: ${grantId}`}
            </CustomPagesHeading>
            {grantId && isLegacy && (
              <TimeLine
                grantTimeline={grantTimeline}
                enteredDate={enteredDate}
                fastPass={fastPass}
                startDate={startDate}
                isGrantAgreementPayment={isGrantAgreementPayment}
                scheduleIdForSpawns={props.scheduleIdForSpawns}
                grantAgreementId={grantAgreementId}
              />
            )}
            <div className="ml-auto right-align">
              <PrintComponents
                className="i_print"
                trigger={
                  <StyleLessButton id="btnPrint">
                    <IconPadding>
                      <img src={printIcon} alt="Print" />
                      <PrintText>PRINT</PrintText>
                    </IconPadding>
                  </StyleLessButton>
                }
              >
                <ViewGrantDetailsPrint
                  scheduleId={scheduleId}
                  spawnId={spawnId}
                  currentScheduleId={currentScheduleId}
                  grantId={grantId}
                  accountName={accountName}
                  accountNumber={accountNumber}
                  enteredDate={enteredDate}
                  status={status}
                  checkIssuedDate={checkIssuedDate}
                  checkNumber={checkNumber}
                  charityInfo={charityInfo}
                  prProps={purposeRecognition}
                  codeValueMappingData={codeValueMappingData}
                  publishName={publishName}
                  amountAllocation={amountAllocation}
                  scheduleType={scheduleType}
                  setEdit={props.enableEdit}
                  history={history}
                />
              </PrintComponents>
            </div>
            {/* Commented as per bugfix/OW-346
            <PagePrintButton
              className="ml-auto"
              contentRef={() => printRef.current}
              printClick={() =>
                analyticsHandler(
                  "print",
                  "",
                  `Print${
                    scheduleType === "recurring"
                      ? ` - Recurring Grant`
                      : ` - One Time Grant`
                  }`
                )
              }
            /> */}
          </div>
          <PageAccountSummary
            key="accountName"
            label={accountName}
            value={accountNumber}
            dataName="accountName"
          />
          <StatusSection>
            <InfoInline title="Entered Date:" value={enteredDate} />
            <InfoInline title="Current Status:" value={status} />
            {(status === 'Payment issued' ||
              status === 'Payment completed') && (
              <>
                {checkIssuedDate && checkIssuedDate !== 'Invalid date' && (
                  <InfoInline title="Issued Date:" value={checkIssuedDate} />
                )}
                {checkNumber ? (
                 <InfoInline title="Check Number:" value={checkNumber} />
                ) : (
                  <InfoInline title="Check Number:" value="Electronic" />
                )}
              </>
            )}
          </StatusSection>
          <ClearedDateSection>
            {status === 'Payment completed' ? (
              <>
                {checkClearedDate ? (
                  <InfoInline
                    title="Check cleared date:"
                    value={checkClearedDate}
                  />
                ) : (
                  ''
                )}
                {checkClearedDate === 0 && (
                  <InfoInline
                    title="Check cleared date:"
                    value={<>&mdash;</>}
                  />
                )}
              </>
            ) : (
              ''
            )}
          </ClearedDateSection>

          <SectionMediumDivider smallMarginTop />
          <Step1Summary
            charityInfo={charityInfo}
            purposeRecognition={prProps}
            codeValueMappingData={codeValueMappingData}
          />
          <SectionMediumDivider smallMarginTop smallMarginBottom />
          <PermissionToPublish publish={publishName} />
          <SectionMediumDivider smallMarginTop />


          {spawnId && checkSpawnEdit(status,scheduleStatus,csrBusinessFunction) && role && role.access !== 'Read Only'?
          <>
            <EditSpawn accountId={accountId} selectedAllocations={amountAllocation.allocations} allocationType={amountAllocation.allocationType} availableBalance = {props.availableBalance} drillRef = {ref => editSpawnRef.current = ref } scheduleIdForSpawns={props.scheduleIdForSpawns} spawnId={spawnId}/> 
             <ContentProvider
             types={[Types.PAGE_DISCLAIMERS]}
             pages={["Recommend a Grant - Allocation"]}
           >
               <ItemHeading>Please Note</ItemHeading>
               <CommonListWrapper>
                 <ContentMessage
                   page="Recommend a Grant - Allocation"
                   type={Types.PAGE_DISCLAIMERS}
                   property="field_disclaimer_content"
                   html
                 />
               </CommonListWrapper>
           </ContentProvider>
           </>
          :
          <Step2Summary
             data-test='handle-edit'
               {...amountAllocation}
               edit={editable({spawnId,allowEdit:false, ...props, role })}
               handleEdit={() => {
                 if (scheduleType === 'recurring') {
                   setShowAllocationEdit(true);
                 } else {
                   props.enableEdit();
                   history.push('/grants/activity/edit/allocation-schedule');
                 }
               }}
             /> }
          {scheduleType === 'recurring' && (
            <>
              <SectionMediumDivider smallMarginTop />
              <Heading
                title="Recurring Grant Schedule"
                data-test='handle-edit1'
                edit={
                  false
                }
                handleEdit={() => {
                  props.enableEdit();
                  history.push({
                    pathname: '/grants/activity/edit/step2A',
                    state: { scheduleId: scheduleId },
                  });
                }}
              />
              <RecurringTable
                edit={role && role.access !== 'Read Only' && status === 'Active'}
                grantsDetails={scheduleData}
                spawns={spawns}
                scheduleId={scheduleId}
                cancelApi={cancelApi}
                addGrantApiCall={addGrantApiCall}
                viewHandle={viewHandle}
                scheduleStatus={status}
                csrBusinessFunction={csrBusinessFunction}
              />
            </>
          )}
          {!scheduleId &&
            status !== 'Payment issued' &&
            status !== 'Payment completed' &&
            status !== 'Denied' &&
            status !== 'Cancelled' &&
            status !== 'Reversed' && (
              <>
                <SectionMediumDivider smallMarginTop smallMarginBottom />
                <PreviewLetter
                  {...props}
                  analyticsHandler={analyticsHandler}
                  downloadLink={props.paymentLetterLink}
                />
                <SectionMediumDivider smallMarginTop />
              </>
            )}

          {(status === 'Denied' ||
            status === 'Cancelled' ||
            status === 'Reversed' ||
            status === 'Active' ||
            status === 'Entered' ||
            status === 'Complete') && (
            <SectionMediumDivider smallMarginTop smallMarginBottom />
          )}
          {(status === 'Payment issued' || status === 'Payment completed') && (
            <>
              <SectionMediumDivider smallMarginTop smallMarginBottom />
              <PreviewLetter
                {...props}
                sample={false}
                analyticsHandler={analyticsHandler}
                downloadLink={props.paymentLetterLink}
              />
              <SectionMediumDivider smallMarginTop />
            </>
          )}
          {grantId && props.scheduleIdForSpawns && (
            <Note data-test='on-click'>
              <LabelWrapper>
                This spawn belongs to a recurring grant schedule (Schedule
                ID:&nbsp;
                <LinkWrapper
                  inline
                  onClick={() =>
                    scheduleRedirect(props.history, props.scheduleIdForSpawns)
                  }
                >
                  {props.scheduleIdForSpawns})
                </LinkWrapper>
                &nbsp; consisting of {props.noOfPayments} payments.
              </LabelWrapper>
            </Note>
          )}
        </div>
        {(spawnId && checkSpawnEdit(status,scheduleStatus,csrBusinessFunction) && role && role.access !== 'Read Only')?

        (<FlowFooter
            data-test="flow-footer"
            page={"Edit Grant"}
            enableCancelPopUp={true}
            enableUpdate={true}
            edit={true}
            keyProperty={"Cancel Edit Grant" }
            keyPropertyUpdate={"Cancel Edit Grant"}
            handleUpdateCta={()=>{
              editSpawnRef.current.submitHandler(()=>{scheduleRedirect(props.history, props.scheduleIdForSpawns)})
            }}
            handleUpdateCancel={() =>{ scheduleRedirect(props.history, props.scheduleIdForSpawns)}
            }
            exitPopupTitle="Cancel grant recommendation"
          />)
            :
            <ButtonWrapper>
           <SecondaryNavigation  readonly = {role && role.access === 'Read Only'}/>
        {!isGrantAgreementPayment
            ? showRegrant(role, scheduleType, status)
              ? reGrantRender(
                  props.availableBalance,
                  props.grantAmount,
                  regrantHandler
                )
              : (role && role.access !== 'Read Only') && (
                  <ViewEditBtnContainer data-test='on-click1'>
                    <GeneralButton
                      id="btnRecommendAnotherGrant"
                      type="functional"
                      text="RECOMMEND ANOTHER GRANT"
                      onClick={() => {
                        try {
                          props.newGrant();
                          history.push({
                            pathname: '/grants/recommend',
                          });
                        } catch (error) {
                          recordError(error);
                        }
                      }}
                    />
                  </ViewEditBtnContainer>
                )
            : ''}
            </ButtonWrapper>
}   
      </FixedWidth>

      <DrupalPopup
        html={true}
        page={'Edit Grant'}
        show={showAllocationEdit}
        defaultPrimaryLabel={'Ok'}
        defaultTitle={'Grant Allocation and Schedule'}
        defaultSecondaryLabel={'Cancel'}
        keyProperty={'Allocation and Schedule Edit Grant'}
        defaultDescription={
          'Any edits made to this grant will apply to all upcoming grants within the recurring schedule. Any changes made may require additional research by Vanguard Charitable.'
        }
        data-test='Cta'
        primaryCta={() => {
          props.enableEdit();
          history.push('/grants/activity/edit/allocation-schedule');
        }}
        secondaryCta={() => setShowAllocationEdit(false)}
        alertId="allocation-edit"
      />

      <DrupalPopup
        html={true}
        page={'Edit Grant'}
        show={showSpawnRegrantWarning}
        defaultPrimaryLabel={'Ok'}
        defaultTitle={'Regranting Spawn'}
        defaultSecondaryLabel={'Cancel'}
        keyProperty={'Regrant Spawn'}
        defaultDescription={
          'Regranting a spawn of a recurring schedule grant will result in a recommendation of a one-time grant, not the entire schedule.'
        }
        data-test='Cta1'
        primaryCta={() => {
          regrantFlow(props.enableRegrant, history);
        }}
        secondaryCta={() => setShowSpawnRegrantWarning(false)}
        alertId="regrant-Spawn"
      />

      <DrupalPopup
        html={true}
        page={'Edit Grant'}
        show={grantPurposeEdit}
        defaultPrimaryLabel={'Ok'}
        defaultTitle={'Grant Purpose & Recognition'}
        defaultSecondaryLabel={'Cancel'}
        keyProperty={'Purpose and Recognition Edit Grant'}
        defaultDescription={
          'Any edits made to this grant will apply to all upcoming grants within the recurring schedule. Any changes made may require additional research by Vanguard Charitable.'
        }
        data-test='Cta2'
        primaryCta={() => {
          props.enableEdit();
          history.push('/grants/activity/edit/purpose');
        }}
        secondaryCta={() => setGrantPurposeEdit(false)}
        alertId="purpose-edit"
      />
    </ContentProvider>
  );
};

const mapStateToProps = (state) => ({
  ...viewGrantDetailDerivedStates(state.toJS()),
  charityAddress: state.getIn(['recommendGrant', 'selectedCharityAddress']),
  allocations: state.getIn(['recommendGrant', 'allocations']),
  spawns: state.getIn(['recommendGrant', 'spawns']),
  advisors: state.getIn(['globalState', 'advisors']),
  codeValueMappingData: state.getIn(['globalState', 'codeValueMappingData']),
  csrBusinessFunction: state.getIn([
    'globalState',
    'csr',
    'business_functions',
  ]),
});

export const mapDispatchToProps = (dispatch) => ({
  fetchGrantData: (data) => dispatch(fetchGrantData(data)),
  enableEdit: (payload) => dispatch(enableEdit(payload)),
  resetEdit: (payload) => dispatch(resetEdit(payload)),
  fetchAdvisors: (payload) => dispatch(fetchAccountAdvisors(payload)),
  cancelSingleSpawn: (payload) => dispatch(cancelSchedule(payload)),
  cancelAllSpawns: (payload) => dispatch(cancelAllSchedules(payload)),
  addSpawn: (payload) => dispatch(addSpawn(payload)),
  changeScheduleId: (payload) => dispatch(changeScheduleId(payload)),
  newGrant: (data) => dispatch(newGrant(data)),
  enableRegrant: (data) => dispatch(enableRegrant(data)),
  cancelGrantFlow: () => dispatch(cancelGrantFlow()),
  grantDetailsLoader: () => dispatch(grantDetailsLoader()),
});

ViewGrantDetails.propTypes = {
  accountName: PropTypes.string,
  addSpawn: PropTypes.func,
  additionalComments: PropTypes.string,
  advisors: PropTypes.array,
  allShares: PropTypes.bool,
  allSharesAllPools: PropTypes.bool,
  allocations: PropTypes.arrayOf(
    PropTypes.shape({
      allShare: PropTypes.bool,
      grantAmount: PropTypes.string,
      grantPercentage: PropTypes.string,
      id: PropTypes.number,
      name: PropTypes.string,
      units: PropTypes.number,
    })
  ),
  amountType: PropTypes.string,
  availableBalance: PropTypes.number,
  cancelAllSpawns: PropTypes.func,
  cancelAllStatus: PropTypes.bool,
  cancelGrantFlow: PropTypes.func,
  cancelSingleSpawn: PropTypes.func,
  cancelSingleStatus: PropTypes.bool,
  changeScheduleId: PropTypes.func,
  charityAddress: PropTypes.shape({
    addressLine1: PropTypes.string,
    addressLine2: PropTypes.string,
    addressLine3: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zipCode: PropTypes.string,
  }),
  charityEin: PropTypes.string,
  charityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  charityInterest: PropTypes.string,
  charityName: PropTypes.string,
  checkIssuedDate: PropTypes.string,
  checkNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  codeValueMappingData: PropTypes.object,
  csrBusinessFunction: PropTypes.any,
  enableEdit: PropTypes.func,
  enableRegrant: PropTypes.func,
  endDate: PropTypes.string,
  enteredDate: PropTypes.string,
  eventName: PropTypes.string,
  fastPass: PropTypes.any,
  fetchAdvisors: PropTypes.func,
  fetchGrantData: PropTypes.func,
  frequency: PropTypes.string,
  grantAmount: PropTypes.string,
  grantDetailsLoader: PropTypes.func,
  grantRecognition: PropTypes.string,
  grantTimeline: PropTypes.any,
  history: PropTypes.object,
  inHonorOfName: PropTypes.string,
  inMemoryOfName: PropTypes.string,
  includeAdvisorInfo: PropTypes.bool,
  isGrantAgreementPayment: PropTypes.bool,
  loading: PropTypes.bool,
  location: PropTypes.object,
  missionaryLocation: PropTypes.string,
  missionaryName: PropTypes.string,
  newGrant: PropTypes.func,
  noOfPayments: PropTypes.string,
  notifyFirstName: PropTypes.string,
  notifyLastName: PropTypes.string,
  paymentLetterLink: PropTypes.string,
  publishName: PropTypes.bool,
  purposeCertification: PropTypes.bool,
  purposeId: PropTypes.number,
  purposeName: PropTypes.string,
  resetEdit: PropTypes.func,
  scheduleIdForSpawns: PropTypes.string,
  scheduleStatus: PropTypes.string,
  scheduleType: PropTypes.string,
  spawns: PropTypes.arrayOf(
    PropTypes.shape({
      allShareallPool: PropTypes.string,
      allocationType: PropTypes.string,
      amount: PropTypes.string,
      charityDetails: PropTypes.object,
      checkIssuedDate: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
      checkIssuedDateStr: PropTypes.string,
      checkNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      dollarbased: PropTypes.bool,
      grantAllocation: PropTypes.array,
      issueDate: PropTypes.string,
      issueDateStr: PropTypes.string,
      paymentId: PropTypes.number,
      purpose: PropTypes.string,
      recognition: PropTypes.string,
      recordStatus: PropTypes.string,
      scheduleId: PropTypes.number,
      spawnId: PropTypes.number,
      status: PropTypes.string,
    })
  ),
  standardLanguage: PropTypes.string,
  startDate: PropTypes.string,
  staticContext: PropTypes.any,
  status: PropTypes.string,
  thirdParty: PropTypes.string,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ViewGrantDetails)
);
